import {
  ThemeFontSizeDefinition,
  ThemeFontSizeName,
  ThemeFontSizeNameDesktop,
  ThemeFontSizeNameMobile,
} from '../../font.model';
import { M3TypeScale } from '../../base/config/m3-type-scale';


const FontSizesDesktop: Record<ThemeFontSizeNameDesktop, ThemeFontSizeDefinition> = {
  'headline-1': ['3.125rem', { lineHeight: '4.375rem', letterSpacing: 'normal' }],   // 50/70
  'headline-2': ['2.375rem', { lineHeight: '3.3125rem', letterSpacing: 'normal' }],  // 38/53
  'headline-3': ['2rem', { lineHeight: '2.8125rem', letterSpacing: 'normal' }],      // 32/45
  'headline-4': ['1.75rem', { lineHeight: '2.5rem', letterSpacing: 'normal' }],      // 28/40
  'headline-5': ['1.5rem', { lineHeight: '2.125rem', letterSpacing: 'normal' }],     // 24/34
  'headline-6': ['1.25rem', { lineHeight: '1.75rem', letterSpacing: 'normal' }],     // 20/28

  'body-1': ['1rem', { lineHeight: '1.375rem', letterSpacing: 'normal' }],
  'body-2': ['0.875rem', { lineHeight: '1.25rem', letterSpacing: 'normal' }],
  'body-3': ['0.75rem', { lineHeight: '1rem', letterSpacing: 'normal' }],
  'body-4': ['0.625rem', { lineHeight: '0.875rem', letterSpacing: 'normal' }],
};

const FontSizesMobile: Record<ThemeFontSizeNameMobile, ThemeFontSizeDefinition> = {
  'headline-1-m': ['2rem', { lineHeight: '2.5rem', letterSpacing: 'normal' }],
  'headline-2-m': ['1.75rem', { lineHeight: '2.5rem', letterSpacing: 'normal' }],
  'headline-3-m': ['1.5rem', { lineHeight: '2rem', letterSpacing: 'normal' }],
  'headline-4-m': ['1.25rem', { lineHeight: '1.5rem', letterSpacing: 'normal' }],
  'headline-5-m': ['1.125rem', { lineHeight: '1.5rem', letterSpacing: 'normal' }],
  'headline-6-m': ['1rem', { lineHeight: '1.5rem', letterSpacing: 'normal' }],

  'body-1-m': ['1rem', { lineHeight: '1.375rem', letterSpacing: 'normal' }],
  'body-2-m': ['0.875rem', { lineHeight: '1.25rem', letterSpacing: 'normal' }],
  'body-3-m': ['0.75rem', { lineHeight: '1rem', letterSpacing: 'normal' }],
  'body-4-m': ['0.625rem', { lineHeight: '0.875rem', letterSpacing: 'normal' }],
};

export const FontSizes: Record<ThemeFontSizeName, ThemeFontSizeDefinition> = {
  ...M3TypeScale,
  ...FontSizesDesktop,
  ...FontSizesMobile,
};
